<template>
    <div>
        <div v-show="showAcordos" class="acessibilidade">
            <div class="content">
                <div class="col-sm-12 px-5">
                    <h3 class="text-center " v-if="acordos.length == 0">Você ainda não realizou nenhuma negociação!</h3>
                    <div class="">
                        <div class="card my-card" style="background-color: #E8F5E9; height: 100%; max-width: fit-content" :style="[!telaGrande ? {'min-width': '400px !important'} : '']">
                            <article class="text-justify pa-4">
                                Por motivos de segurança, seu boleto pode requisitar senha para ser aberto. Esta senha são os quatro primeiros números do seu CPF/CNPJ.
                                Exemplo: Se o seu CPF/CNPJ for 09899, digitar 0989 para abrir o boleto
                                Caso não consiga visualizar o boleto anexado, acesse o link abaixo e faça o download do programa Adobe Acrobat PDF.
                                <a href="http://get.adobe.com/br/reader/"> http://get.adobe.com/br/reader/</a>
                            </article>
                        </div>
                    </div>
                    <div class="my-collapse mb-4 mt-3" v-for="(acordo, i) in acordos" :key="i">
                        <div class="content-between py-1 ml-1" style="align-items: stretch" :aria-expanded="acordo.show">
                            <div class="content-start " style="align-items: center">
                                <strong class="" style="min-width: 200px"> {{acordo.cdContrato}} - {{acordo.situacaoAcordo}} - </strong>
                                <span class="">
                                    {{acordo.Credor.Nome}}  
                                </span>

                            </div>
                            <!-- <div>
                                {{acordo.SituacaoAcordo}}
                            </div> -->
                            <button class="bg-first-light right btn btn-small  ml-1" style="height: 40px; width: 200px" @click="acordo.show = !acordo.show">
                                <i v-if="!acordo.show" class="fas fa-plus"></i>
                                <i v-else class="fas fa-minus"></i>
                                Detalhes 
                            </button>
                        </div>
                        <div class="content-start pa-2 content-collapse" :class="{'nowrap': telaGrande}" v-if="acordo.show" style="align-items: stretch">
                            <div class="mr-4" style="width: 250px">
                                <div class="btn-group dropdown" v-if="acordo.TermoAceite > 0 || acordo.ConfissaoDivida > 0">
                                    <button class="btn dropdown-toggle" id="dropdownTermos" style="min-width: 160px;background-color: #FF7043" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-file-contract pr-2"></i>
                                        Termos
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownTermos">
                                        <button class="dropdown-item" v-show="acordo.TermoAceite != 0" @click="verTermoAcordo(acordo)">
                                            <i class="fas fa-file-alt pr-2 corIconesToolbar"></i>
                                            Termo de Acordo                             
                                        </button>
                                        <div class="dropdown-divider" v-show="acordo.TermoAceite != 0"></div>
                                        <button class="dropdown-item" v-show="acordo.ConfissaoDivida != 0" @click="verTermoConfissao(acordo)">
                                            <i class="fas fa-file pr-2 corIconesToolbar"></i>
                                            Termo de Confissão                             
                                        </button>
                                    </div>                            
                                </div>
                                <!-- Example single danger button -->
                                
                                <div class="mr-3 mt-2" v-if="showBoleto">
                                    <button v-if="acordo.permiteEmissaoBoleta" class="btn bg-verde-dark focoDropdown" id="dropdownBoleto" style="min-width: 160px;" @click="abrirDropdownBoleto(acordo, i)">
                                        <i class="fas fa-dollar-sign pr-2"></i>
                                        Boleto <i class="fas fa-caret-down pl-1 font-size-1-2"></i> 
                                    </button>
                                    <div 
                                        id="listaBoleta" 
                                        class="positon-absolute focoDropdown"
                                        v-show="acordo.showDropdownBoleto" 
                                        >
                                        <v-card class="py-2">
                                            <button class="dropdown-item focoDropdown" @click="enviarBoletaEmail(acordo.chaveNegociacao, acordo)" >
                                                <i class="fas fa-envelope pr-2 corIconesToolbar"></i>
                                                Enviar Email
                                            </button>
                                            <div class="dropdown-divider"></div>
                                            <button class="dropdown-item focoDropdown" @click="imprimirBoleta(acordo.chaveNegociacao, acordo)">
                                                <i class="fas fa-print pr-2 corIconesToolbar"></i>
                                                Imprimir
                                            </button>
                                            <div class="dropdown-divider"></div>
                                            <button class="dropdown-item focoDropdown" @click="enviarBoletaSMS(acordo.chaveNegociacao, acordo)">
                                                <i class="fas fa-sms pr-2 corIconesToolbar"></i>
                                                Enviar SMS
                                            </button>
                                        </v-card>
                                    </div>
                                </div>
                                <!-- bugado 
                                    <div class="mr-3 mt-2 dropdown">
                                    <button class="btn dropdown-toggle bg-verde-dark" id="dropdownBoleto" style="min-width: 160px;" data-bs-toggle="dropdown" data-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-dollar-sign pr-2"></i>
                                        Boleto
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownBoleto" v-show="acordo.permiteEmissaoBoleta">
                                        <button class="dropdown-item" @click="enviarBoletaEmail(acordo.chaveNegociacao)" >
                                            <i class="fas fa-envelope pr-2 corIconesToolbar"></i>
                                            Enviar Email
                                        </button>
                                        <div class="dropdown-divider"></div>
                                        <button class="dropdown-item" @click="imprimirBoleta(acordo.chaveNegociacao)">
                                            <i class="fas fa-print pr-2 corIconesToolbar"></i>
                                            Imprimir
                                        </button>
                                        <div class="dropdown-divider"></div>
                                        <button class="dropdown-item" @click="enviarBoletaSMS(acordo.chaveNegociacao)">
                                            <i class="fas fa-sms pr-2 corIconesToolbar"></i>
                                            Enviar SMS
                                        </button>
                                    </div>
                                </div> -->
                                <!-- <button class="btn mt-2" v-show="acordo.PermitePagamentoComCartao" @click="pagarCartaoCredito(acordo)" style="background-color: #FFC107">
                                    <i class="fas fa-credit-card pr-2"></i>
                                    Cartão de Crédito
                                </button>   -->
                            </div>
                            <div>
                                <p>
                                    <span v-html="acordo.resumoAcordo"></span> 
                                    </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showCreditCard" style="margin-top: -60px">
            <div class="content">
                <div class="form-group pa-2">
                    <label for="valor" class="colorLabel">Valor</label>
                    <div class="input-group input-group-lg" style="width: 180px">
                        <input type="text"
                        v-model="acordoPagarCartao.PlanoNegociadoCartao.TotalAcordo"
                        v-money="money"
                        id="valor"
                        class="form-control"
                        disabled
                        >
                    </div>
                </div>
                <div class="form-group pa-2">
                    <label for="parcela" class="colorLabel">Quantidade de parcelas</label>
                    <div class="input-group input-group-lg" style="width: 180px">
                        <input 
                        v-model="acordoPagarCartao.PlanoNegociadoCartao.QtParcelas"
                        id="parcela"
                        class="form-control"
                        disabled
                        >

                        <!-- <select 
                        v-model="qtParcela"
                        id="parcela"
                        class="form-control"
                        disabled
                        >
                        <option :value="i" v-for="i in acordoPagarCartao.PlanoNegociadoCartao.QtParcelas" :key="i">{{i}}</option>
                        </select> -->
                    </div>
                </div>
            </div>
            <div class="content" style="margin-top: -40px">
                <Cartao :card="card" style="max-width: 500px;"></Cartao>
            </div>
            <div class="content">
                <v-btn @click="voltarAcordos()">
                    <i class="fas fa-arrow-left pr-2 corIconesToolbar"></i>  Voltar
                </v-btn>
                <v-btn color="success" @click="autorizacaoCredito()">
                    Finalizar Pagamento
                </v-btn>
            </div>
        </div>
        <v-dialog v-model="activeDialog" role="dialog">
            <v-card>
                    <h3 id="titleDialog" tabindex="-1" class="headline grey lighten-2 pa-3">
                        {{titleDialog}}
                        <v-btn class="right" aria-label="Fechar" icon @click="activeDialog = false" style="margin-top: -5px"><i class="fas fa-times fa-2x" style="color: grey "></i></v-btn>
                    </h3>
                <v-card-text  >
                    <center-element class="pt-3">
                        <div class=" scroll-y scroll-x style-teste"  style="max-width: 900px">
                            <div id="termo" role="document"></div>
                        </div>
                    </center-element>
                </v-card-text>
            </v-card>
        </v-dialog>

        <Carregando></Carregando>
    </div>
</template>
<script>
import Vuex from '@/vuex/store'
import { formataNumeroG } from '@/global'
import {getNegociacoes, postBaixaAcordoCartao, getEmails } from '@/service/service_autoatendimento/autoatendimento'
import {getBoletaSMS, postBoletaEmail, getArquivoBoleta} from '@/service/service_autoatendimento/boleta'
import { getTermoConfissao, getTermoAcordo } from '@/service/service_autoatendimento/documento'
import {postAutorizacao, postCaptura} from '@/service/service_pagamento/pagamento'
// import printJS from 'print-js'
import jquery from 'jquery'
import Carregando from './MyComponents/Carregando'
import CenterElement from './MyComponents/CenterElement.vue'
import Cartao from './MyComponents/Cartao'
import bus from '@/service/bus'
import { setTimeout } from 'timers';
import { nextTick } from 'process'
// jquery(document).click(function(e) {
//     console.log('e.target sem fn', e.target)
//     // if (!menuAberto) return;
//     // var foraMenu = !jquery(e.target).closest('#mySidenav')[0];
//     // if (foraMenu) fechaSideNav();
// })

export default {
    components: { Carregando, CenterElement, Cartao },
    data(){
        return {
            valor: 99.8,
            titleDialog: '',
            activeDialog: false,
            acordos: [],
            showCreditCard: false,
            showAcordos: true,
            showBoleto: true,
            // showDropdownBoleto: false,
            card: {
                cardName: "",
                cardNumber: "",
                cardMonth: "",
                cardYear: "",
                cardCvv: "",
                type: "",
                codType: 0,
                niceType: "",
                config: ''
            },
            acordoPagarCartao: '',
            parcelas: [],
            qtParcela: 1,
            money: {
                decimal: ',',
                thousands: '',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false /* doesn't work with directive */
            },
        }
    },
    mounted() {
        if(window.innerWidth >= 750)  Vuex.commit('SET_TELA', true)        
        window.onresize = ()=>{
            if(window.innerWidth >= 750) Vuex.commit('SET_TELA', true)  
            else Vuex.commit('SET_TELA', false)
        }
        this.carregaAcordos()
    },
    computed: {
        telaGrande(){
            return Vuex.state.large
        }
    },
    methods: {
        verTermoAcordo(item) {
                let obj = {
                    chaveDivida: item.chaveNegociacao,
                    codigo: item.TermoAceite
                }
                bus.$emit('load-in', {text: 'Carregando'})
                getTermoAcordo(obj).then(response => {
                    bus.$emit('load-out')
                    let d = document.getElementById('termo')
                    d.innerHTML = response.data.Retorno
                    this.titleDialog = 'Termo de Acordo'
                    this.activeDialog = true
                    setTimeout(() => {
                        let title = document.getElementById('titleDialog')
                        title.focus()
                    }, 500)
                }).catch(() => {
                    bus.$emit('load-out')
                })
        },
        verTermoConfissao(item) {
            let obj = {
                chaveNegociacao: item.chaveNegociacao,
                codigo: item.ConfissaoDivida,
                parcela: 0
            }
            bus.$emit('load-in', {text: 'Carregando'})
            getTermoConfissao(obj).then(response => {
                bus.$emit('load-out')
                let d = document.getElementById('termo')
                d.innerHTML = response.data.Retorno
                this.titleDialog = 'Termo de Confissão'
                this.activeDialog = true
                setTimeout(() => {
                    let title = document.getElementById('titleDialog')
                    title.focus()
                }, 500)
            }).catch(() => {
                bus.$emit('load-out')
            })
        },
        carregaAcordos(){
            this.showCreditCard = false
            this.showAcordos = true
            // bus.$emit('load-in', {text: 'Carregando'})
            if(Vuex.state.acordos.length == 0) {
                getNegociacoes(sessionStorage.getItem('user_codigo')).then((retorno) => {
                    this.acordos = retorno.data.Retorno.map(item => {
                        item.show = false
                        item.showDropdownBoleto = false
                        return item
                    })
                    Vuex.commit('SET_ACORDOS', this.acordos)
                    // bus.$emit('load-out')
                }).catch(() => {
                    // bus.$emit('load-out')
                    // console.log(err)
                })
            } else this.acordos = Vuex.state.acordos
        },
        abrirDropdownBoleto (acordo, parIndex) {
            acordo.showDropdownBoleto = !acordo.showDropdownBoleto
            this.acordos.forEach((el, index) => {
                if (parIndex !== index) {
                    el.showDropdownBoleto = false
                }
            })
            this.showBoleto = false
            nextTick(() => {
                this.showBoleto = true
            })
            this.validarClickFora(acordo)
            
            // let boleta = document.getElementById('listaBoleta')
            // boleta.focus()
        },
        validarClickFora (acordo) {
            // usei jquery para escutar quando clicar na tela dps de abrir o dropdown
            jquery(document).click(function(e) {
                var clickDentro = jquery(e.target).closest('.focoDropdown')[0]
                if (!clickDentro) {
                    // se o click não for dentro da div focoDropdown a lista fecha
                    acordo.showDropdownBoleto = false
                }
                // if (!menuAberto) return;
                // var foraMenu = !jquery(e.target).closest('#mySidenav')[0];
                // if (foraMenu) fechaSideNav();
            })
        },
        listaBoletoFocusOut (acordo) {
            acordo.showDropdownBoleto = false
        },
       enviarBoletaEmail(chave, acordo) {
            try {
                getEmails().then(r =>{
                    let listaEmails =  r.data.Retorno.email
                    this.$swal({
                        input: 'select',
                        title: 'Selecione um e-mail para destino da mensagem:',
                        text: 'Você poderá cadastrar um novo e-mail em meu cadastro',
                        showCancelButton: true,
                        cancelButtonText: 'Cancelar',
                        confirmButtonText:'Enviar',
                        reverseButtons: true,
                        validationMessage: "E-mail inválido",
                        inputOptions: listaEmails,
                        showLoaderOnConfirm: true,
                        allowOutsideClick: () => !this.$swal.isLoading(),
                        preConfirm: (ret) => {
                            let obj = {
                                emailDestino: listaEmails[ret],
                                chave: chave
                            }
                            try {
                                return postBoletaEmail(obj).then(() => {
                                }).catch(error => {
                                    this.$swal.showValidationMessage(`Erro: ${error.message}`)
                                })
                            } catch (er) {
                                this.$swal.showValidationMessage(`Erro: ${er.message}`)
                            }
                        }
                    }).then((result) => {
                        if(result.value) {
                            this.$swal({
                                type: 'success',
                                title: 'E-mail enviado!'
                            })
                        }
                        acordo.showDropdownBoleto = false
                    })
                })

            } catch(error) {
                bus.$emit('load-out')
                this.$swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: error.response.data.Message
                })
                acordo.showDropdownBoleto = false
            }

        },
        // enviarBoletaEmail(chave) {
        //     getEmails().then(r =>{
        //         let listaEmails =  r.data.Retorno.email
        //         this.$swal({
        //             input: 'input',
        //             inputOptions: listaEmails,
        //             title: 'Informe o e-mail de destinos:',
        //             showCancelButton: true,
        //             cancelButtonText: 'Cancelar',
        //             confirmButtonText:'Enviar',
        //             reverseButtons: true,
        //             validationMessage: "E-mail inválido",
        //             // text: 'ok',
        //             // inputAttributes: {
        //             //     id: 'myInput',
        //             //     maxlength: 50
        //             // },
        //             // inputValue: 'ok@ok.ocm' ,
        //             showLoaderOnConfirm: true,
        //             allowOutsideClick: () => !this.$swal.isLoading(),
        //             preConfirm: (ret) => {

        //                 let obj = {
        //                     emailDestino: listaEmails[ret],
        //                     chave: chave
        //                 }
        //                 try {
        //                     return postBoletaEmail(obj).then(() => {
        //                     }).catch(error => {
        //                         this.$swal.showValidationMessage(`Erro: ${error.message}`)
        //                     })
        //                 } catch (er) {
        //                     this.$swal.showValidationMessage(`Erro: ${er.message}`)
        //                 }
        //             }
        //         }).then((result) => {
        //             if(result.value) {
        //                 this.$swal({
        //                     type: 'success',
        //                     title: 'E-mail enviado!'
        //                 })
        //             }
        //         })   

        //     })
        // },
        imprimirBoleta(chave, acordo) {
           
            try {
                bus.$emit('load-in', {text: 'Carregando'})
                getArquivoBoleta(chave).then(response => {
                    bus.$emit('load-out')
                    let base = response.data.Retorno.arquivoPDFBase64
                    let bin = atob(base.replace(/\s/g, ''))
                    let len = bin.length
                    let buffer = new ArrayBuffer(len)
                    let view = new Uint8Array(buffer)
                    for(let i=0; i<len; i++) {
                        view[i] = bin.charCodeAt(i)
                    }
                    let  pdfBlob = new Blob([view], {type: "application/pdf"})
                    let url = URL.createObjectURL(pdfBlob)
                    window.open(url)
                    acordo.showDropdownBoleto = false
                }).catch((error) => {
                    bus.$emit('load-out')
                    this.$swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: error.response.data.Message
                    })
                    acordo.showDropdownBoleto = false
                })
            } catch(error) {
                bus.$emit('load-out')
                this.$swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: error.response.data.Message
                })
                acordo.showDropdownBoleto = false
            }
            
        },
        enviarBoletaSMS(chave, acordo) {
            this.$swal({
                input: 'text',
                title: 'Informe um número de celular:',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText:'Enviar',
                reverseButtons: true,
                inputAttributes: {
                    id: 'myInput',
                    maxlength: 11
                },
                showLoaderOnConfirm: true,
                inputValidator: (value) => {
                    if (!value) return 'Informe um número de celular'
                    else {
                        let txt = value.replace(/([(]|[)]|-| )/g, '')
                        if (isNaN(txt) || txt.length !== 11) return 'Número inválido'
                    } 
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
                onOpen: (el) => {
                    var container = jquery(el)
                    container.find('#myInput').mask('(00) 00000-0000')
                },
                preConfirm: (ret) => {
                    let obj = {
                        telefone: ret.replace(/([(]|[)]|-| )/g, ''),
                        chave: chave
                    }
                    try {
                        return getBoletaSMS(obj).then(() => {
                        }).catch(error => {
                            this.$swal.showValidationMessage(`Erro: ${error.message}`)
                        })
                    } catch (er) {
                        this.$swal.showValidationMessage(`Erro: ${er.message}`)
                        acordo.showDropdownBoleto = false
                    }
                }
            }).then((result) => {
                if(result.value) {
                    this.$swal({
                        type: 'success',
                        title: 'SMS enviado!'
                    })
                }
                acordo.showDropdownBoleto = false
            })            
        },
        pagarCartaoCredito(item) {
            let txt = JSON.stringify(item)
            let obj = JSON.parse(txt)
            obj.PlanoNegociadoCartao.TotalAcordo = formataNumeroG(item.PlanoNegociadoCartao.TotalAcordo, '2', ',', '')
            this.showAcordos = false
            this.showCreditCard = true
            this.acordoPagarCartao = obj
        },
        autorizacaoCredito() {
            let vrTxt = this.acordoPagarCartao.PlanoNegociadoCartao.TotalAcordo.split(' ')[1].replace(',','.')
            var data = {
                IdentificacaoPedido: this.acordoPagarCartao.chaveNegociacao,
                Cartao: {
                    Bandeira: this.card.codType,
                    Numero: this.card.cardNumber.replace(/ /g, ''),
                    Nome: this.card.cardName,
                    DataExpiracao: this.card.cardMonth + '/' + this.card.cardYear,
                    CodigoSeguranca: this.card.cardCvv
                },
                VrCompra: Number(vrTxt),
                NrParcelas: this.acordoPagarCartao.PlanoNegociadoCartao.QtParcelas,
                RespJurosParcelamento: this.card.config.JurosParcelamento,
                DadosTeste: {
                    NrTeste: "1",
                    Captura: "N",
                    SalvaCartao: "N",
                    CancelaTransacao: "N",
                    VrCapturaParcial: 0
                }
            }
            if(data.Cartao.Numero.length !== 16 || data.Cartao.Nome == '' || this.card.cardMonth == '' || this.card.cardYear == '' || this.card.cardCvv == '') {
                this.$swal({
                    type: 'warning',
                    title: 'Preencha todos os campos do cartão corretamente.'
                })
                return
            }
            // console.log('data', JSON.stringify(data))
            try {
                bus.$emit('load-in', {text: 'Carregando'})
                postAutorizacao(data, this.card.config).then(response =>{
                    if(response.data.Status == 'Error') {
                        bus.$emit('load-out')
                        this.$swal({
                            type: 'error',
                            text: response.data.StatusText
                        })
                        return
                    }
                    if(response.data.Retorno.AuthorizationCode != null) {
                        this.capturaCredito(response.data.Retorno.PaymentId, response.data.Retorno.AuthorizationCode)
                    } else {
                        bus.$emit('load-out')
                        this.$swal({
                            type: 'warning',
                            text: response.data.Retorno.ReturnMessage
                        })
                    }
                })
            } catch(error) {
                bus.$emit('load-out')
                this.$swal({
                    type: 'error',
                    text: error.message
                })
            }

        },
        capturaCredito(id, autho) {
            try {
                postCaptura({PaymentId: id}).then(() => {
                    this.baixarAcordoCartao(autho)
                }).catch(() => {
                    bus.$emit('load-out')
                })
            } catch(error) {
                bus.$emit('load-out')
            }
        },
        baixarAcordoCartao(autho) {
            postBaixaAcordoCartao({tokenAutorizacao: autho, chaveacordo: this.acordoPagarCartao.chaveNegociacao}).then(() => {
                bus.$emit('load-out')
                this.$swal({
                    type: 'success',
                    title: 'Pagamento realizado!' 
                })
                Vuex.commit('SET_ACORDOS', [])
                this.carregaAcordos()
            }).catch(() => {
                bus.$emit('load-out')
            })
        },
        voltarAcordos() {
            this.showCreditCard = false
            this.showAcordos = true
        }
    }
}
</script>